/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `PSČ`
};

const da_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Postnummer`
};

const de_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Postleitzahl`
};

const en_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Postcode`
};

const es_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Código postal`
};

const fr_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Code postal`
};

const hu_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Postai irányítószám`
};

const it_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `CAP`
};

const nl_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Postcode`
};

const pl_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Kod pocztowy`
};

const pt_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `CEP`
};

const sv_postcode = /** @type {(inputs: {}) => string} */ () => {
	return `Postnummer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const postcode = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.postcode(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("postcode", locale)
	if (locale === "cs") return cs_postcode(inputs)
	if (locale === "da") return da_postcode(inputs)
	if (locale === "de") return de_postcode(inputs)
	if (locale === "en") return en_postcode(inputs)
	if (locale === "es") return es_postcode(inputs)
	if (locale === "fr") return fr_postcode(inputs)
	if (locale === "hu") return hu_postcode(inputs)
	if (locale === "it") return it_postcode(inputs)
	if (locale === "nl") return nl_postcode(inputs)
	if (locale === "pl") return pl_postcode(inputs)
	if (locale === "pt") return pt_postcode(inputs)
	return sv_postcode(inputs)
};